<template>
  <div class="config_main_manage_background">
    <!-- 设置页面的内容区域 -->
    <div class="config_main_manage_page_wraper">
      <div class="config_main_manage_page_content">
        <!-- 设置页面  内容区域样式   以上部分都是公共样式 -->
        <config-hang @click.native="configAddSceneBtnHandle">
          <span slot="config_hang_ele2">添加一个新区域</span>
          <img slot="config_hang_ele4" src="~assets/img/config/youjiantou.png" alt />
        </config-hang>
        <config-title-hang>
          <span slot="config_title_hang_ele2">全部的区域</span>
          <input slot="config_title_hang_ele7" type="text" placeholder="快速搜索" v-model="scerchValue" />
          <span slot="config_title_hang_ele6" @click="allRegionOperate(0)">取消所有</span>
          <span slot="config_title_hang_ele5" @click="allRegionOperate(1)">选择所有</span>
        </config-title-hang>

        <!-- 服务器返回的所有区域列表 -->
        <config-hang
          v-for="(value , index) in serveRegionListData.allRegion"
          :key="index"
          @click.native="selectRegionBtnHandle(value)"
          :selectState="computedSelectRegionState(value)"
        >
          <span slot="config_hang_ele2">{{value.regionName}}</span>
          <img slot="config_hang_weixuan" src="~assets/img/config/weixuan.png" alt />
          <img slot="config_hang_xuanzhong" src="~assets/img/config/xuanzhong.png" alt />
        </config-hang>

        <div class="public_config_que_ren_btn" @click="saveReturnBtnHandle">保存并返回</div>
      </div>
    </div>
  </div>
</template>

<script>
import topNav from "components/common/topnav/topnav";
import topNavItem from "components/common/topnav/topnavitem";
import configHang from "components/common/config/config-hang";
import configTitleHang from "components/common/config/config-title-hang";
import { mediumslateblue } from "color-name";
import confiSceneMainVue from "../configScenePage/confiSceneMain.vue";
import { objectClone } from "common/tool";

export default {
  data() {
    return {
      serveRegionListData: {
        ///服务器返回的所有区域信息的数据
        allRegion: [], ///所有的区域信息
        followRegion: [], ////收藏的区域信息
      },
      serveRegionListDataBack: {
        ///服务器返回的所有区域信息的数据
        allRegion: [], ///所有的区域信息
        followRegion: [], ////收藏的区域信息
      },
      scerchValue: "", // 搜索使用
      selectRegionList: [
        ///选中的区域LIST
      ],
    };
  },
  components: {
    topNav,
    topNavItem,
    configHang,
    configTitleHang,
  },
  methods: {
    selectRegionBtnHandle(value) {
      let ListLength = this.selectRegionList.length;
      for (let i = 0; i < ListLength; i++) {
        if (value.regionId === this.selectRegionList[i].regionId) {
          ////这个区域已经是勾选的，则删除
          this.selectRegionList.splice(i, 1);
          return;
        }
      }
      this.selectRegionList.push(value); ///这个区域还未勾选   勾选添加
      console.log(this.selectRegionList);
    },
    saveReturnBtnHandle() {
      ///保存并返回按钮点击了
      if (this.selectRegionList.length === 0) {
        this.$toast("请至少选择一个区域！");
        return;
      }
      //为了加搜索框增加的代码 去除搜索框当前视图 没有显示已勾选的区域  
        let length1 = this.serveRegionListData.allRegion.length
        let length2 = this.selectRegionList.length
        let judge =0;
        console.log("11111111")
        for(let i=0;i<length2;i++){
          judge = 0;
          for(let j=0; j<length1;j++){
            if( this.selectRegionList[i].regionId == this.serveRegionListData.allRegion[j].regionId ){
                ///有的保留
                judge =1;
                break;
            }
          }
          if(judge == 0){
            this.selectRegionList.splice(i,1);
            length2--;
            i--;
          }
        }

      ////提交用户选择的区域ID到仓库
      this.$store.dispatch("asyUpdataSelectRegionList", this.selectRegionList);
      // console.log(this.$store.state.configinfo.OneSceneinfo)
      this.$router.go(-1);
      // this.$router.replace({ path:this.OneSceneinfo.path, query:this.OneSceneinfo })
    },
    configReturnContronBtnHandle() {
      ////配置页面的主页返回按钮被点击了
      this.$router.replace(this.$store.state.publicinfo.configReturnPath);
    },
    configAddSceneBtnHandle() {
      ////添加一个新区域按钮按下了
      this.$router.push({ path: "/RegionManage", query: { type: "config" } });
    },
    computedSelectRegionState(value) {
      let ListLength = this.selectRegionList.length;
      for (let i = 0; i < ListLength; i++) {
        if (value.regionId === this.selectRegionList[i].regionId) {
          return true;
        }
      }
      return false;
    },
    //业内数据搜索显示  //搜索使用
    seraceDataShow(charData) {
      if (
        this.serveRegionListData.allRegion &&
        this.serveRegionListDataBack.allRegion
      ) {
        //数据是合法存在的
        this.serveRegionListData.allRegion = this.serveRegionListData.allRegion.concat(
          this.serveRegionListDataBack.allRegion
        );
        this.serveRegionListDataBack.allRegion.length = 0;
        if (charData.match(/^[ ]*$/)) {
          //说明为空 或多个空
        } else {
          let dataLength = this.serveRegionListData.allRegion.length;
          for (let i = 0; i < dataLength; i++) {
            if (
              this.serveRegionListData.allRegion[i].regionName.indexOf(
                charData
              ) == -1
            ) {
              // && this.serveRegionListData.allRegion[i].checked == false
              // 说明没有这个字符
              this.serveRegionListDataBack.allRegion.push(
                this.serveRegionListData.allRegion[i]
              );
              this.serveRegionListData.allRegion.splice(i, 1);
              dataLength--;
              i--;
            }
          }
        }
        console.log(this.serveRegionListData.allRegion);
      }
    },
    allRegionOperate(data) {

      if (data == 0) {
        //s说明是取消所有的选择区域
        this.selectRegionList.splice(0, this.selectRegionList.length);
      } else if (data == 1) {
        //说明是选择所有的区域
        let length1 = this.serveRegionListData.allRegion.length
        for(let i=0;i<length1;i++){
          this.selectRegionList.push(this.serveRegionListData.allRegion[i]);
        }
      }
    }
  },
  watch: {
    scerchValue: function (val) {
      console.log("发生变化" + val);
      this.seraceDataShow(val); //新增页内搜索
    },
  },
  computed: {},
  created() {
    console.log("created阶段");

    /// 请求区域信息接口，获取数据
    this.$request({
      method: "post",
      url: "/region/findRegion",
      data: {
        token: this.$store.state.token,
      },
    })
      .then((res) => {
        if (res.data.code != 0) {
          this.$showTipsToast(3, res.data.message);
          ////说明信息填写错误,控制失败了，
          return;
        } else {
          ////、控制成功了
          this.serveRegionListData = res.data.data; ////拿到服务器返回的数据结果
          console.log(this.serveRegionListData);
          // this.selectRegionList = this.$store.state.configinfo.selectRegionList;

          objectClone(
            this.selectRegionList,
            this.$store.state.configinfo.selectRegionList
          );

          // this.$showTipsToast(1, "获取成功", true); ////提示框
        }
      })
      .catch((error) => {
        console.log(error);
      });

    // this.OneSceneinfo = this.$store.state.configinfo.OneSceneinfo;
    //需要把进来时的仓库的状态更新进来，
    // this.OneSceneinfo.regionName = this.$store.state.configinfo.OneSceneinfo.regionName;
    // this.OneSceneinfo.regionId = this.$store.state.configinfo.OneSceneinfo.regionId;
  },
};
</script>

<style>
</style>